// this is an autogenerated file from App/Account/Content/Settings/Content/Onboarding/ApptReminders/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_Onboarding_ApptReminders{
  result: appt_reminders_migrate(twilio_setup_done: false) {
    ok
    message
  }
}

`